import { APIClient } from '../api_helper';
import * as url from './url_helper';
import qs from 'qs';

const config = require('../../config');
const WATER_RIGHTS_BASE = config.api.REACT_APP_SPED_WATER_RIGHTS_API_URL;

const apiClient = new APIClient();

// Helper function to stringify query parameters
const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// Get Document Type List with Query (for remote operations)
export const getDocumentTypeListQuery = params => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_DOCUMENT_TYPES}?${stringifyParams(
			params
		)}`
	);
};

// Get Document Type List with Query
export const getDocumentTypeList = params => {
	const queryParams = {
		filters: {
			disable: {
				$eq: false,
			},
		},
        // populate: ['creation_user', 'modification_user'],
		pagination: {
			page: 1,
			pageSize: 1000,
		},
		sort: ['name:asc'],
		...params,
	};

	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_DOCUMENT_TYPES}?${stringifyParams(
			queryParams
		)}`
	);
};

// Get Single Document Type
export const getDocumentType = document_type_id => {
	return apiClient.get(
		`${WATER_RIGHTS_BASE}${url.GET_DOCUMENT_TYPE}${document_type_id}`
	);
};

// Add New Document Type
export const addNewDocumentTypeApi = document_type => {
	return apiClient.create(
		`${WATER_RIGHTS_BASE}${url.POST_DOCUMENT_TYPE}`,
		document_type
	);
};

// Update Document Type
export const updateDocumentTypeApi = document_type => {
	return apiClient.put(
		`${WATER_RIGHTS_BASE}${url.PUT_DOCUMENT_TYPE}${document_type._id}`,
		document_type
	);
};

// Delete Document Type
export const deleteDocumentTypeApi = document_type_id => {
	return apiClient.delete(
		`${WATER_RIGHTS_BASE}${url.DELETE_DOCUMENT_TYPE}${document_type_id}`
	);
};

// Check if Document Type Exists
export const checkDocumentTypeExistsApi = name => {
	const queryParams = {
		filters: {
			name: {
				$eq: name,
			},
		},
		fields: ['_id'],
		pagination: {
			page: 1,
			pageSize: 1,
		},
	};

	return apiClient
		.get(
			`${WATER_RIGHTS_BASE}${
				url.CHECK_DOCUMENT_TYPE_EXISTS
			}?${stringifyParams(queryParams)}`
		)
		.then(response => {
			return { exists: response && response.length > 0 };
		})
		.catch(() => {
			return { exists: false };
		});
};
